import React, { useEffect, useState } from "react";
import Headline5 from "../../components/headings/Headline5";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import Styles from "./styles.module.scss"
import Headline4 from "../../components/headings/Headline4"
import { Icon } from "@iconify/react"
import HealthInsurancePurchaseModal from "../healthInsurancePurchase"
import { submitInsuranceDetails , getInuranceDetails } from "./services"
import mixpanelData from "../../utils/mixpanel";

export type HealthInsuranceForm = {
  nameIdProof: string;
  insuranceType: string;
}

interface Props {
  onClose?: any;
  clickHandler?: any;
}

const validationSchema = Yup.object({
  nameIdProof: Yup.string().required("Field is required"),
  insuranceType: Yup.string().required("Field is required")
})

const HealthInsuranceModal: React.FC<Props> = ({ onClose, clickHandler }) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
  }

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState
  } = useForm<HealthInsuranceForm>(formOptions);
  
  const loginId = localStorage.getItem('loginId')
  const [modal , setModal] = useState<Boolean>(false)
  const [insuranceData, setInsuranceData] = useState<any>()
  const [disabled, setDisabled] = useState<Boolean>(false)
  const email = localStorage.getItem('Email') 
  const Name = localStorage.getItem('Name')

  useEffect(() => {
    getHealthInsuranceDetails(loginId)
  }, [loginId])

  const getHealthInsuranceDetails = (loginId: any) => {
    
    getInuranceDetails(loginId).then((response) => {
      if(response && response.status === 1){
        setInsuranceData(response.data)
      }
    })
  }

  const saveInsuranceDetails = (data: any) => {
    setDisabled(true)
    let body = {
      "candidateLoginId": loginId,
      "insuranceData": {
          "dateOfBirth": data.dateOfBirth,
          "nameIdProof": data.nameIdProof,
          "insuranceType": data.insuranceType
        }
    }  
    submitInsuranceDetails(body).then((response) => {
      if(response && response.status === 1){
        setDisabled(true)
        setInsuranceData(response.data)
        setModal(false)
        mixpanelData('New MWP - Health Insurance', {
          'distinct_id': email,
          'Candidate Email': email,
          'Name': Name,
          'Type of Health Insurance': data.insuranceType,
          'Date of Birth': data.dateOfBirth
        })
      }
    })
  }

  const openHealthInsuranceModal = () => {
      setModal(true)
  }
  
  return (
    <Modal title={"Request Rating"} size="medium" onClose={onClose}>
      <section>
        {insuranceData && insuranceData.length === 0 &&
          <div className={Styles.descriptionWrapper}>
            <Icon icon="icon-park-outline:cross-society" color="green" width="50" />
            <div className={Styles.description}>
              <Headline4>Purchase health insurance!</Headline4>
              <p>Working with ellow, we understand your health and well-being are paramount. That's why we offer a comprehensive health insurance plan designed specifically for contractors like you. By enrolling in our plan, you'll have access to a range of health benefits, including group health insurance coverage and wellness perks. Enjoy the convenience of discounted offers on doctor teleconsultations, pharmacy services, diagnostic tests, and much more. All of this is available to you at an affordable average monthly cost between Rs. 1500/- to Rs 1800/-. Invest in your health and secure your future by applying for our exclusive health insurance plan today.</p>
            </div>
            <div className={Styles.button}> 
              <Button variant="outlined" size="xxsmall" onClick={onClose} >Cancel</Button>
              <Button variant="primary" size="xxsmall"  onClick={() => {openHealthInsuranceModal()}}>Opt In</Button>
            </div>
          </div>
        }
        {insuranceData && insuranceData.length > 0 && 
          <div className={Styles.descriptionWrapper}>
            <Icon icon="healthicons:health-data-security-outline" color="green" width="50" />
            <div className={Styles.description}>
              <Headline4>Thank you for your interest!</Headline4> 
              <p>Thank you for showing interest in opting ellow health insurance , Our team will reach out to you soon. In case of any queries Please contact us at <a style={{'color':'#14A800'}} href="mailto:team@ellow.io">hr@ellow.io</a></p>
            </div>
            <div className={Styles.button}> 
              <Button variant="primary" size="xxsmall" onClick={onClose} >Ok</Button>
            </div>
          </div> 
        }      
        {modal && <HealthInsurancePurchaseModal  clickHandler={saveInsuranceDetails}  onClose={() => setModal(false)} disabled={disabled}/>}
        </section>
    </Modal>
  )
}

export default HealthInsuranceModal;